import { useState } from 'react';
import Layout from '../../../components/layout/Layout';

export default function GamificacaoDistintivos() {
  const [showModal, setShowModal] = useState(false);
  const [showConquistasModal, setShowConquistasModal] = useState(false);
  const [filtroCategoria, setFiltroCategoria] = useState('todos');

  // Distintivos cadastrados
  const distintivos = [
    {
      id: 1,
      nome: 'Primeira Venda',
      categoria: 'Iniciante',
      icone: '🎯',
      descricao: 'Realize sua primeira venda',
      xp_necessario: 0,
      missao_obrigatoria: 'Primeira Venda',
      nivel_requerido: 'Bronze',
      recorrencia: 'Única',
      conquistado_por: 456,
      ativo: true,
    },
    {
      id: 2,
      nome: 'Vendedor Estrela',
      categoria: 'Vendas',
      icone: '⭐',
      descricao: 'Atinja 100 vendas no mês',
      xp_necessario: 5000,
      missao_obrigatoria: 'Meta de 100 Vendas',
      nivel_requerido: 'Prata',
      recorrencia: 'Mensal',
      conquistado_por: 234,
      ativo: true,
    },
    {
      id: 3,
      nome: 'Mestre dos Serviços',
      categoria: 'Serviços',
      icone: '🏆',
      descricao: 'Complete 50 serviços com excelência',
      xp_necessario: 7500,
      missao_obrigatoria: 'Meta de 50 Serviços',
      nivel_requerido: 'Ouro',
      recorrencia: 'Mensal',
      conquistado_por: 156,
      ativo: true,
    },
    {
      id: 4,
      nome: 'Ativador Premium',
      categoria: 'Clientes',
      icone: '💎',
      descricao: 'Ative 20 novos clientes',
      xp_necessario: 10000,
      missao_obrigatoria: 'Ativação de 20 Clientes',
      nivel_requerido: 'Platina',
      recorrencia: 'Trimestral',
      conquistado_por: 89,
      ativo: true,
    },
    {
      id: 5,
      nome: 'Lenda',
      categoria: 'Elite',
      icone: '👑',
      descricao: 'Alcance o nível Diamante',
      xp_necessario: 50000,
      missao_obrigatoria: null,
      nivel_requerido: 'Diamante',
      recorrencia: 'Única',
      conquistado_por: 23,
      ativo: true,
    },
    {
      id: 6,
      nome: 'Sequência de Ouro',
      categoria: 'Engajamento',
      icone: '🔥',
      descricao: 'Complete missões por 30 dias consecutivos',
      xp_necessario: 3000,
      missao_obrigatoria: null,
      nivel_requerido: 'Bronze',
      recorrencia: 'Mensal',
      conquistado_por: 178,
      ativo: true,
    },
  ];

  // Categorias
  const categorias = ['Iniciante', 'Vendas', 'Serviços', 'Clientes', 'Elite', 'Engajamento'];

  // Conquistas recentes
  const conquistasRecentes = [
    { id: 1, participante: 'João Silva', distintivo: 'Vendedor Estrela', data: '15/01/2024 14:30' },
    { id: 2, participante: 'Maria Santos', distintivo: 'Primeira Venda', data: '15/01/2024 12:15' },
    { id: 3, participante: 'Pedro Costa', distintivo: 'Mestre dos Serviços', data: '15/01/2024 10:45' },
    { id: 4, participante: 'Ana Oliveira', distintivo: 'Sequência de Ouro', data: '14/01/2024 18:20' },
    { id: 5, participante: 'Carlos Souza', distintivo: 'Ativador Premium', data: '14/01/2024 16:30' },
  ];

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Distintivos / Badges</h1>
            <p className="text-sm text-gray-600 mt-1">Gerenciamento de distintivos e conquistas</p>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={() => setShowConquistasModal(true)}
              className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm font-medium whitespace-nowrap"
            >
              <i className="ri-trophy-line mr-2"></i>
              Conquistas Recentes
            </button>
            <button
              onClick={() => setShowModal(true)}
              className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap"
            >
              <i className="ri-add-line mr-2"></i>
              Novo Distintivo
            </button>
          </div>
        </div>

        {/* Filtros */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Categoria</label>
              <select
                value={filtroCategoria}
                onChange={(e) => setFiltroCategoria(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
              >
                <option value="todos">Todas as Categorias</option>
                {categorias.map((cat, index) => (
                  <option key={index} value={cat}>{cat}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Nível Requerido</label>
              <select className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500">
                <option value="">Todos os Níveis</option>
                <option value="bronze">Bronze</option>
                <option value="prata">Prata</option>
                <option value="ouro">Ouro</option>
                <option value="platina">Platina</option>
                <option value="diamante">Diamante</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Buscar</label>
              <input
                type="text"
                placeholder="Nome do distintivo..."
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
              />
            </div>
            <div className="flex items-end">
              <button className="w-full px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm font-medium whitespace-nowrap">
                <i className="ri-filter-3-line mr-2"></i>
                Limpar Filtros
              </button>
            </div>
          </div>
        </div>

        {/* Grid de Distintivos */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {distintivos.map((distintivo) => (
            <div key={distintivo.id} className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
              <div className="flex items-start justify-between mb-4">
                <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center text-3xl shadow-lg">
                  {distintivo.icone}
                </div>
                <div className="flex items-center gap-2">
                  <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                    distintivo.ativo ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                  }`}>
                    {distintivo.ativo ? 'Ativo' : 'Inativo'}
                  </span>
                </div>
              </div>

              <div className="mb-4">
                <h3 className="text-lg font-bold text-gray-900 mb-1">{distintivo.nome}</h3>
                <span className="inline-flex items-center px-2 py-1 bg-purple-100 text-purple-800 rounded-full text-xs font-medium">
                  {distintivo.categoria}
                </span>
              </div>

              <p className="text-sm text-gray-700 mb-4">{distintivo.descricao}</p>

              <div className="space-y-2 mb-4">
                <div className="flex items-center justify-between text-xs">
                  <span className="text-gray-600">XP Necessário:</span>
                  <span className="font-bold text-yellow-600">{distintivo.xp_necessario.toLocaleString('pt-BR')} XP</span>
                </div>
                <div className="flex items-center justify-between text-xs">
                  <span className="text-gray-600">Nível Requerido:</span>
                  <span className="font-medium text-gray-900">{distintivo.nivel_requerido}</span>
                </div>
                <div className="flex items-center justify-between text-xs">
                  <span className="text-gray-600">Recorrência:</span>
                  <span className="font-medium text-gray-900">{distintivo.recorrencia}</span>
                </div>
                {distintivo.missao_obrigatoria && (
                  <div className="flex items-center justify-between text-xs">
                    <span className="text-gray-600">Missão:</span>
                    <span className="font-medium text-gray-900">{distintivo.missao_obrigatoria}</span>
                  </div>
                )}
              </div>

              <div className="pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="text-xs text-gray-600">Conquistado por</p>
                  <p className="text-lg font-bold text-teal-600">{distintivo.conquistado_por}</p>
                </div>
                <div className="flex items-center gap-2">
                  <button className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-teal-600 hover:bg-teal-50 rounded transition-colors">
                    <i className="ri-edit-line text-base"></i>
                  </button>
                  <button className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors">
                    <i className="ri-user-add-line text-base"></i>
                  </button>
                  <button className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-red-600 hover:bg-red-50 rounded transition-colors">
                    <i className="ri-delete-bin-line text-base"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Modal Novo Distintivo */}
        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto">
              <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
                <h2 className="text-xl font-bold text-gray-900">Novo Distintivo</h2>
                <button
                  onClick={() => setShowModal(false)}
                  className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>

              <div className="p-6 space-y-6">
                {/* Informações Básicas */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Informações Básicas</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-2">Nome do Distintivo *</label>
                      <input
                        type="text"
                        placeholder="Ex: Vendedor Estrela"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Categoria *</label>
                      <select className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500">
                        <option value="">Selecione...</option>
                        {categorias.map((cat, index) => (
                          <option key={index} value={cat}>{cat}</option>
                        ))}
                        <option value="nova">+ Nova Categoria</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Ícone (Emoji) *</label>
                      <input
                        type="text"
                        placeholder="🏆"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
                      />
                      <p className="text-xs text-gray-500 mt-1">Use emojis ou faça upload de imagem SVG/PNG</p>
                    </div>
                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-2">Descrição *</label>
                      <textarea
                        rows={3}
                        placeholder="Descreva como conquistar este distintivo..."
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
                      ></textarea>
                    </div>
                  </div>
                </div>

                {/* Requisitos */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Requisitos</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">XP Necessário *</label>
                      <input
                        type="number"
                        placeholder="5000"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Nível Requerido</label>
                      <select className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500">
                        <option value="">Nenhum</option>
                        <option value="bronze">Bronze</option>
                        <option value="prata">Prata</option>
                        <option value="ouro">Ouro</option>
                        <option value="platina">Platina</option>
                        <option value="diamante">Diamante</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Missão Obrigatória</label>
                      <select className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500">
                        <option value="">Nenhuma</option>
                        <option value="1">Vendedor Estrela</option>
                        <option value="2">Mestre dos Serviços</option>
                        <option value="3">Ativador Premium</option>
                        <option value="4">Suporte 5 Estrelas</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Regra de Recorrência *</label>
                      <select className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500">
                        <option value="unica">Única</option>
                        <option value="diaria">Diária</option>
                        <option value="semanal">Semanal</option>
                        <option value="mensal">Mensal</option>
                        <option value="trimestral">Trimestral</option>
                        <option value="anual">Anual</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Instruções */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Instruções</h3>
                  <textarea
                    rows={4}
                    placeholder="Instruções detalhadas de como conquistar este distintivo..."
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
                  ></textarea>
                </div>

                {/* Status */}
                <div>
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input type="checkbox" defaultChecked className="w-4 h-4 text-teal-600 border-gray-300 rounded focus:ring-teal-500" />
                    <span className="text-sm font-medium text-gray-700">Distintivo Ativo</span>
                  </label>
                </div>
              </div>

              <div className="sticky bottom-0 bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
                <button
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap"
                >
                  Cancelar
                </button>
                <button className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap">
                  Salvar Distintivo
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Conquistas Recentes */}
        {showConquistasModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto">
              <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
                <h2 className="text-xl font-bold text-gray-900">Conquistas Recentes</h2>
                <button
                  onClick={() => setShowConquistasModal(false)}
                  className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>

              <div className="p-6">
                <div className="space-y-3">
                  {conquistasRecentes.map((conquista) => (
                    <div key={conquista.id} className="bg-gray-50 rounded-lg p-4 border border-gray-200 flex items-center justify-between">
                      <div className="flex items-center gap-4">
                        <div className="w-12 h-12 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center">
                          <i className="ri-trophy-fill text-white text-xl"></i>
                        </div>
                        <div>
                          <p className="text-sm font-semibold text-gray-900">{conquista.participante}</p>
                          <p className="text-xs text-gray-600 mt-1">Conquistou: {conquista.distintivo}</p>
                        </div>
                      </div>
                      <div className="text-right">
                        <p className="text-xs text-gray-600">{conquista.data}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}
